<template>
    <section class="tool-holder">
        <div class="tool-container">
            <div class="tool__question-holder">
                <h3 class="tool__subtitle">{{ question.number }}</h3>
                <h2 class="tool__title">{{ question.title }}</h2>
                <div class="tool__text-holder" v-if="question.text">
                    <p class="tool__text">{{ question.text }}</p>
                </div>
            </div>
            <div class="tool__answer-holder">
                <div  v-for="(answer, index) in question.answers" :key="answer.text + index" class="inputfield" :class="{ 'inputfield--disabled' : isInputfieldDisabled }">
                    <label
                        :for="answer.text.toLowerCase().split(' ').join('-')"
                        class="label"
                    >{{ answer.text }}</label>
                    <input
                        :id="answer.text.toLowerCase().split(' ').join('-')"
                        type="text"
                        v-model="answers[index]"
                        :placeholder="answer.placeholder ? answer.placeholder : answer.text"
                    />
                    <span class="error-text"></span>
                </div>
                <div v-if="question.slug === 'huishoudelijk-verbruik'" class="checkbox-holder checkbox-holder--boxed" :class="{ 'success' : checkboxChecked }">
                    <input
                        type="checkbox"
                        id="verbruikunknown"
                        v-model="checkboxChecked"
                        ref="checkbox"
                    />
                    <label for="verbruikunknown">Ik weet niet wat mijn jaarlijks verbruik is</label>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import store from '../../store/store';

export default {
    props: {
        question: {
            type: Object
        }
    },

    data() {
        return {
            store,
            isInputfieldDisabled: false,
            answers: null,
            checkboxChecked: false,
        }
    },

    watch: {
        checkboxChecked(value) {
            this.isInputfieldDisabled = false;
            this.store.questionInfo[this.store.currentQuestionIndex].showSideQuestions = false;
            if (value) {
                this.isInputfieldDisabled = true;
                this.store.questionAnswers[this.store.currentQuestionIndex].answers = [0, 0]
                this.store.questionInfo[this.store.currentQuestionIndex].showSideQuestions = true;
            }
        },
    },

    created() {
        this.answers = this.question.isSideQuestion ? this.store.questionAnswers[this.store.currentQuestionIndex].sideQuestions.answers[this.store.currentSideQuestionIndex] : this.store.questionAnswers[this.store.currentQuestionIndex].answers;
    },

    methods: {

        addToStore() {
            if (this.question.isSideQuestion) {
                this.addSideQuestionToStore();
                return;
            }

            this.store.questionAnswers[this.store.currentQuestionIndex].answers = this.answers;
        },

        addSideQuestionToStore() {
            this.store.questionAnswers[this.store.currentQuestionIndex].sideQuestions.answers[this.store.currentSideQuestionIndex] = this.answers;
        },
    },

    updated() {
        // Reset answers for when there are multiple radio questions after each other. This will prevent the template to have a success class on the fields when the user hasn't selected anything
        this.answers = this.question.isSideQuestion ? this.store.questionAnswers[this.store.currentQuestionIndex].sideQuestions.answers[this.store.currentSideQuestionIndex] : this.store.questionAnswers[this.store.currentQuestionIndex].answers;
    }
}
</script>
